import React, {Component} from "react";
import { Radio, Input, Spin } from "antd";
import { CalendarOutlined, UnorderedListOutlined, LoadingOutlined } from "@ant-design/icons";
import "./Dashboard.scss";
import ChitiOverview from "../../chiti/ChitiOverview";
import PayItemListOverview from "../../chiti/PayItemListOverview";
import ReportOverview from "../../chiti/ReportOverview";
import NewChitiItem from "../../chiti/NewChitiItem";
import { Modal } from "antd";

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 'month',
            showAddModal: false,
            keyword: '',
            searchKeyword: '',
            searchVersion: 0,
            loading: true,
        };
        this.chitiOverviewRef = React.createRef();
        this.payItemListRef = React.createRef();
        this._loadingTimer = null;
    }

    componentDidMount() {
        // Show spinner for up to 800ms — hide sooner if content signals ready
        this._loadingTimer = setTimeout(() => this.setState({ loading: false }), 500);
    }

    componentWillUnmount() {
        clearTimeout(this._loadingTimer);
    }

    handleAddExpense = () => {
        console.log('Button clicked, opening modal');
        this.setState({ showAddModal: true }, () => {
            console.log('Modal state:', this.state.showAddModal);
        });
    }

    handleModalClose = () => {
        this.setState({ showAddModal: false });
        // Reload both views
        if (this.chitiOverviewRef.current && this.chitiOverviewRef.current.reloadOverview) {
            this.chitiOverviewRef.current.reloadOverview();
        }
        if (this.payItemListRef.current && this.payItemListRef.current.handleOk) {
            this.payItemListRef.current.handleOk();
        }
    }

    handleSearch = () => {
        this.setState(prev => ({ searchKeyword: this.state.keyword, searchVersion: prev.searchVersion + 1, activeTab: 'daily' }));
    }

    handleTabChange = (e) => {
        this.setState({ activeTab: e.target.value });
    }

    render() {
        if (!this.props.isAuthenticated) {
            return null;
        }

        const { activeTab, showAddModal, keyword, searchKeyword, searchVersion, loading } = this.state;
        console.log('Dashboard render - showAddModal:', showAddModal);

        if (loading) {
            return (
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: 'calc(100vh - 84px)',
                    flexDirection: 'column',
                    gap: 16,
                }}>
                    <Spin indicator={<LoadingOutlined style={{ fontSize: 40, color: '#1890ff' }} spin />} />
                    <span style={{ color: '#8c8c8c', fontSize: 14 }}>Loading…</span>
                </div>
            );
        }

        return (
            <div className="dashboard-container">
                <div className="dashboard-content">
                    {/* Header with Radio Buttons */}
                    <div className="dashboard-header" style={{
                        background: 'white',
                        borderRadius: '16px',
                        padding: '16px 24px',
                        margin: '16px',
                        boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '12px'
                    }}>
                        <Input.Search
                            placeholder="Search description, store, item name..."
                            value={keyword}
                            onChange={(e) => this.setState({ keyword: e.target.value })}
                            onSearch={this.handleSearch}
                            enterButton
                            size="large"
                            allowClear
                            onClear={() => this.setState({ keyword: '', searchKeyword: '' })}
                        />
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                            <Radio.Group
                                value={activeTab}
                                onChange={this.handleTabChange}
                                buttonStyle="solid"
                                size="large"
                                className="dashboard-radio-group"
                            >
                                <Radio.Button value="month">
                                    <CalendarOutlined style={{ marginRight: '8px' }} />
                                    Monthly
                                </Radio.Button>
                                <Radio.Button value="daily">
                                    <UnorderedListOutlined style={{ marginRight: '8px' }} />
                                    Daily
                                </Radio.Button>
                            </Radio.Group>
                            <button
                                onClick={this.handleAddExpense}
                                style={{
                                    width: '40px',
                                    height: '40px',
                                    background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
                                    border: 'none',
                                    borderRadius: '50%',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '24px',
                                    color: 'white',
                                    boxShadow: '0 4px 12px rgba(24, 144, 255, 0.4)',
                                    transition: 'all 0.3s'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'scale(1.1)';
                                    e.currentTarget.style.boxShadow = '0 6px 16px rgba(24, 144, 255, 0.5)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'scale(1)';
                                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(24, 144, 255, 0.4)';
                                }}
                            >
                                +
                            </button>
                        </div>
                    </div>

                    {/* Content Area */}
                    <div className="dashboard-tab-content">
                        <div style={{ display: activeTab === 'month' ? 'block' : 'none' }}>
                            <ChitiOverview ref={this.chitiOverviewRef} />
                        </div>
                        <div style={{ display: activeTab === 'daily' ? 'block' : 'none' }}>
                            <PayItemListOverview ref={this.payItemListRef} searchKeyword={searchKeyword} searchVersion={searchVersion} />
                        </div>
                    </div>

                    {/* Add Expense Modal */}
                    {console.log('Rendering modal, showAddModal:', showAddModal)}
                    <Modal
                        title={<span style={{ fontSize: '18px', fontWeight: 700, color: '#1a1a1a' }}>Add Expense</span>}
                        open={showAddModal}
                        visible={showAddModal}
                        onCancel={() => this.setState({ showAddModal: false })}
                        footer={null}
                        width="90%"
                        style={{ maxWidth: '440px', top: 40, borderRadius: '16px', overflow: 'hidden' }}
                        bodyStyle={{ padding: '20px', background: '#fafafa', borderRadius: '0 0 16px 16px' }}
                        destroyOnClose={true}
                        maskClosable={false}
                        centered
                        className="modern-modal"
                    >
                        <NewChitiItem
                            item={null}
                            closeModal={this.handleModalClose}
                        />
                    </Modal>
                </div>
            </div>
        );
    }
}

export default Dashboard;
